module.exports = __webpack_public_path__ + "img/logo.1db01b60.png";